import { Map } from 'immutable';

import { sliceReducer, composeReducers } from '../../lib/reducers';
import * as constants from './constants';

import { createReducer as createFormWidgetReducer } from '../../components/Form/Widget';

import * as actions from './actions';

function baseReducer(state, action) {
  switch (action.type) {
    case actions.UPDATE.REQUEST: {
      return state.setIn([action.payload.form, 'isLoading'], true);
    }

    case actions.UPDATE.SUCCESS: {
      return state.mergeIn(
        [action.payload.form],
        {
          isLoading: false,
          isEditable: false,
        },
      );
    }

    case actions.UPDATE.FAILURE: {
      return state.mergeIn(
        [action.payload.form],
        {
          isLoading: false,
        },
      );
    }

    default: {
      return state;
    }
  }
}

export default composeReducers([
  sliceReducer(
    [constants.CUSTOMER_FORM_MAIN],
    createFormWidgetReducer(constants.CUSTOMER_FORM_MAIN),
  ),
  sliceReducer(
    [constants.CUSTOMER_FILES_FORM],
    createFormWidgetReducer(constants.CUSTOMER_FILES_FORM),
  ),
  sliceReducer(
    [constants.CUSTOMER_ORGANISATION_FORM],
    createFormWidgetReducer(constants.CUSTOMER_ORGANISATION_FORM),
  ),
  baseReducer,
], new Map());
